<template>
  <div class="playground-container">
    <h2>图片裁剪器测试</h2>

    <div class="image-section">
      <!-- 显示已上传或裁剪后的图片 -->
      <div v-if="croppedImage" class="preview-image">
        <img :src="croppedImage" alt="裁剪后的图片">
        <div class="image-actions">
          <BaseElButton @click="resetImage">重置图片</BaseElButton>
        </div>
      </div>

      <!-- 上传图片按钮 -->
      <div v-else class="upload-section">
        <input
          ref="fileInput"
          type="file"
          accept="image/*"
          style="display: none"
          @change="handleFileChange"
        >
        <BaseElButton @click="triggerFileInput">选择图片</BaseElButton>
      </div>
    </div>

    <!-- 裁剪器组件 -->
    <NewImageCropper
      v-if="showCropper"
      :img="imageObject"
      :fixedRatio="true"
      @close="closeCropper"
      @crop-change="handleCropChange"
      @upload="handleUpload"
      @error="handleError"
    />
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import NewImageCropper from '@/components/NewImageCropper.vue'

export default defineComponent({
  name: 'Playground',
  components: {
    NewImageCropper,
  },
  setup () {
    const fileInput = ref(null)
    const showCropper = ref(false)
    const imageObject = ref(null)
    const croppedImage = ref(null)
    const cropResult = ref(null)

    // 触发文件选择
    const triggerFileInput = () => {
      fileInput.value.click()
    }

    // 处理文件选择
    const handleFileChange = (event) => {
      const file = event.target.files[0]
      if (!file) return

      // 检查文件类型
      const validTypes = ['image/jpeg', 'image/png', 'image/jpg']
      if (!validTypes.includes(file.type)) {
        window.$message.error('只支持 JPG 和 PNG 格式的图片')
        return
      }

      // 检查文件大小
      // if (file.size > 8 * 1024 * 1024) {
      //   window.$message.error('图片大小不能超过 8MB')
      //   return
      // }

      // 创建 blob URL
      const blob = URL.createObjectURL(file)

      // 设置图片对象
      imageObject.value = {
        blob,
        name: file.name,
        type: file.type,
        size: file.size,
      }

      // 显示裁剪器
      showCropper.value = true

      // 重置文件输入，以便可以再次选择同一文件
      event.target.value = ''
    }

    // 处理裁剪变化
    const handleCropChange = (data) => {
      cropResult.value = data
    }

    // 处理上传
    const handleUpload = ({ form, imgDataUrl }) => {
      // 这里可以调用实际的上传API
      console.log('准备上传表单数据:', form)

      // 模拟上传成功
      setTimeout(() => {
        croppedImage.value = imgDataUrl
        window.$message.success('图片上传成功')
        closeCropper()
      }, 1000)
    }

    // 处理错误
    const handleError = (message) => {
      window.$message.error(message)
    }

    // 关闭裁剪器
    const closeCropper = () => {
      showCropper.value = false
    }

    // 重置图片
    const resetImage = () => {
      croppedImage.value = null
      imageObject.value = null
    }

    return {
      fileInput,
      showCropper,
      imageObject,
      croppedImage,
      triggerFileInput,
      handleFileChange,
      handleCropChange,
      handleUpload,
      handleError,
      closeCropper,
      resetImage,
    }
  },
})
</script>

<style scoped lang="postcss">
.playground-container {
  @apply p-6 max-w-4xl mx-auto;
}

h2 {
  @apply text-2xl font-bold mb-6;
}

.image-section {
  @apply border-2 border-dashed border-gray-300 rounded-lg p-8 flex justify-center items-center min-h-[300px];
}

.preview-image {
  @apply flex flex-col items-center gap-4;
}

.preview-image img {
  @apply max-w-full max-h-[300px] object-contain;
}

.upload-section {
  @apply flex flex-col items-center gap-4;
}
</style>
